import React from 'react'
import AntPopover, { PopoverProps as AntPopoverProps } from 'antd/lib/popover'

export interface PopoverProps extends AntPopoverProps {
  primary?: boolean
}

const Popover = ({ primary, ...props }: PopoverProps) => (
  <AntPopover
    {...props}
  />
)

export default Popover
